// extracted by mini-css-extract-plugin
module.exports = {"text":"KkWP"};